import React from 'react';
import { View } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, Column } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

export const InAppPurchaseList = () => {
    return (
        <View style={[common.alignCenter, common.justifyCenter, common.fullHeight]}>
            <Box
                margin={'s6'}
                padding={'s24'}
                backgroundColor={ds.colorToken.background.neutral.subtler}
                borderColor={ds.colorToken.border.strong}
                borderWidth={1}
                borderRadius={'r16'}
                alignItems={'center'}
            >
                <Column gap={'s12'} alignItems={'center'}>
                    <Text variant={'headlineMedium'} color={ds.colorToken.text.primary} textAlign={'center'}>
                        In-App Purchases Not Supported
                    </Text>
                    <Text variant={'bodyMedium'} color={'neutral300'} textAlign={'center'}>
                        In-app purchases are only available on mobile devices. Please use the mobile app to make
                        purchases.
                    </Text>
                </Column>
            </Box>
        </View>
    );
};
